import React from "react";

import { useOrgModParams } from "src/features/orgmod";
import { Dashboard as BasicHealthDashboard } from "src/modules/basic-health";
import { Dashboard as HtxDashboard } from "src/modules/htx";
import { Dashboard as KtxDashboard } from "src/modules/ktx";
import { Dashboard as LtxDashboard } from "src/modules/ltx";

export const Dashboard: React.FunctionComponent = () => {
	const { mod } = useOrgModParams();
	if (mod === "htx" || mod === "htx_nm") {
		return <HtxDashboard />;
	}
	if (mod === "ktx" || mod === "kd") {
		return <KtxDashboard />;
	}
	if (mod === "basic_health") {
		return <BasicHealthDashboard />;
	}
	if (mod === "ltx") {
		return <LtxDashboard />;
	}
	return null;
};
